import { useMemo } from 'react';
import { LatLng } from 'leaflet';
import { Marker } from '@adamscybot/react-leaflet-component-marker';
import { TransmedicsMaroonPlaneUrl, CarGroundIcon } from '@icons';
import { normalizeCarAngle, normalizePlaneAngle } from '@features/components/LocationTracking/utils/animation.utils';
import { COMPONENT_ICON_OPTS, PULSATION_STYLE } from '@features/components/LocationTracking/constants';
import { DeviceNodeType, DeviceNodeTypeEnum } from '@/api/apis/composer';

type BaseLocationMarkerProps = {
  position: LatLng;
  nodeType: DeviceNodeTypeEnum;
  heading: number;
  pulsating?: boolean;
};

export const BaseLocationMarker = ({ position, nodeType, heading, pulsating = true }: BaseLocationMarkerProps) => {
  const isGround = nodeType === DeviceNodeType.Ground;
  const carAngle = normalizeCarAngle(heading);
  const planeAngle = normalizePlaneAngle(heading);
  const shouldFaceLeft = carAngle < -90 || carAngle > 90;
  const carStyle = useMemo(() => ({ transform: `scaleX(${shouldFaceLeft ? -1 : 1})` }), [shouldFaceLeft]);
  const planeStyle = useMemo(() => ({ transform: `rotate(${planeAngle}deg)` }), [planeAngle]);

  return (
    <Marker
      position={position}
      zIndexOffset={50}
      componentIconOpts={COMPONENT_ICON_OPTS}
      icon={
        <div className="h-12 w-12 relative flex items-center justify-center">
          <div
            className="relative w-12 h-12 rounded-full flex items-center justify-center"
            style={pulsating ? PULSATION_STYLE : undefined}
          >
            {pulsating && (
              <span
                aria-hidden="true"
                className="absolute inset-1 inline-flex rounded-full bg-orange-10 opacity-30 animate-ping"
              />
            )}
            {isGround ? (
              <CarGroundIcon aria-label="Ground vehicle" className="w-8 h-8 text-maroon-20" style={carStyle} />
            ) : (
              <img src={TransmedicsMaroonPlaneUrl} alt="Aircraft" style={planeStyle} />
            )}
          </div>
        </div>
      }
    />
  );
};
